import PropTypes from 'prop-types';
import {SelectEntity} from '@ozgene/gp5.components.select-entity';
import {findTagsBySearch, saveTag} from 'Sbs/service/SbsService';
import CreateTagDialog from 'Sbs/views/CreateTagDialog';

export default function SelectTag(props) {
  const {value, id, placeholder, name, onChange, label, ...restProps} = props;
  const handleCreateEntitySave = async (tag) => saveTag(tag);

  return (
    <SelectEntity
      queryOnSearch
      multiple
      getEntities={findTagsBySearch}
      value={value}
      onChange={onChange}
      label={label}
      placeholder={placeholder}
      CreateEntityDialogComponent={CreateTagDialog}
      onCreateEntitySave={handleCreateEntitySave}
      {...restProps}
    />
  );
}

SelectTag.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

SelectTag.defaultProps = {
  value: [],
  id: null,
  name: null,
  label: 'Tag',
  placeholder: '',
};
